export function formatEarningsValue(value, format = 'full', unit = 'USD') {
  if (value == null || !Number.isFinite(value)) return 'Unavailable';
  const prefix = unit.startsWith('USD') ? '$' : /^(shares|pure)$/.test(unit) ? '' : `${unit} `;
  const sign = value < 0 ? '-' : '';
  const magnitude = Math.abs(value);
  const options = { maximumFractionDigits: 10 };
  let divisor = 1;
  let suffix = '';
  if (format !== 'full') {
    const scale = [[1e12, 'T', 'trillion'], [1e9, 'B', 'billion'], [1e6, 'M', 'million'], [1e3, 'K', 'thousand']]
      .find(([threshold]) => magnitude >= threshold);
    if (scale) {
      divisor = scale[0];
      suffix = format === 'abbreviated' ? scale[1] : ` ${scale[2]}`;
    }
  }
  return `${sign}${prefix}${(magnitude / divisor).toLocaleString('en-US', options)}${suffix}`;
}
